import * as React from 'react';
import data from '../api/data';

import Loading from '../components/Loading';
import Header from '../components/Header';
import ColorList from './ColorList';

interface ColorData {
  hexCode: string;
  name: string;
  viewColor: string;
  colorType: string;
}

interface State {
  initialItems: Array<ColorData>;
  colors: Array<ColorData>;
  loading: Boolean;
  filterTabIndex: number;
}

export default class Grid extends React.Component {
  state: State = {
    initialItems: [],
    colors: [],
    loading: true,
    filterTabIndex: 0
  };

  // color Item 필터 함수
  filterColorItems = (filterBy: string, index: number): void => {
    const { initialItems } = this.state;
    const filteredColors =
      filterBy === '' ? initialItems : initialItems.filter(item => item.colorType === filterBy);

    this.setState({
      colors: filteredColors,
      filterTabIndex: index
    });
  };

  componentDidMount() {
    this.setState({
      initialItems: data.colorDataSet,
      colors: data.colorDataSet,
      loading: false
    });
  }

  render() {
    const { colors, loading, filterTabIndex } = this.state;
    return (
      <div className="wtc-grid">
        {loading && <Loading />}
        {!loading && (
          <div>
            <Header filterColorItems={this.filterColorItems} filterTabIndex={filterTabIndex} />
            <ColorList colors={colors} />
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Grid.tsx